import { styled } from '@mui/system';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import StepConnector from '@mui/material/StepConnector';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(3)} ${theme.spacing(1)}`
  }
}));

export const StyledStepLabel = styled(StepLabel)({
  position: 'relative',
  padding: 0
});

export const StyledStepContent = styled(StepContent)(({ theme }) => ({
  position: 'relative',
  marginTop: 0,
  marginLeft: theme.spacing(1.375),
  borderLeftColor: theme.palette.grey[600],
  borderLeftWidth: 3
}));

export const StyledStepConnector = styled(StepConnector)(({ theme }) => ({
  paddingBottom: 0,
  marginLeft: theme.spacing(1.375),
  '& .MuiStepConnector-line': {
    minHeight: theme.spacing(8),
    borderLeftColor: theme.palette.grey[600],
    borderLeftWidth: 3
  }
}));

export const addNewItemButtonStyle = {
  position: 'absolute',
  right: 50,
  top: -4
};

export const addNewStateButtonStyle = {
  position: 'absolute',
  left: -18,
  bottom: -15
};

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const IconBtn = styled(IconButton)({
  width: 24,
  height: 24,
  '&::before': {
    content: '" "',
    display: 'block',
    position: 'absolute',
    width: 12,
    height: 12,
    backgroundColor: '#FFF',
    zIndex: 1,
    borderRadius: 8
  }
});

export const MultipleArrowCtn = styled('div')({
  position: 'absolute',
  top: -24,
  left: 0,
  gap: 25,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
});

export const lastArrowStyle = {
  top: -24
};

export const disabledStyle = {
  display: 'none'
};

// Swap arrow icon style
export const swapArrowStyle = theme => ({
  color: theme.palette.secondary.main,
  zIndex: 1,
  fontSize: '42px !important',
  width: '40px !important',
  height: '40px !important'
});

export const singleArrowStyle = {
  top: 24,
  left: 0,
  zIndex: 1,
  position: 'absolute'
};
